/* eslint-disable react-hooks/exhaustive-deps */
import { SetStateAction, useEffect, useState } from 'react';
import { Formik } from 'formik';

import SecundButton from 'components/form/buttons/secundButton';
import MiniPopUp from 'components/modal/miniPopUp';
import PanelBoxLayout from 'components/layout/panelBox';
// import { useActions } from "common/hooks/useActions";

import Gap from 'components/gap';
import PrimaryButton from 'components/form/buttons/primaryButton';
import { useActions } from 'common/hooks/useActions';
import DropDown from 'components/form/dropDown';
import DateInput from 'components/form/dateInput';
import OutlineButton from 'components/form/buttons/outLineButton';
// import { ValidationFilterDate } from "common/validations";
import { TransactionTypeEnum } from 'common/enums/index';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  setFilter: SetStateAction<any>;
  filter: any;
}

export default function UserFilterPopup({ setFilter, filter }: IProps) {
  const { MachineIdsRequestAction } = useActions();
  const { machineIds } = useTypedSelector((state) => state.Users);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    MachineIdsRequestAction();
  };

  return (
    <S.Content>
      <MiniPopUp
        popUpStyle={{ width: 245, padding: '0' }}
        buttonNode={
          <SecundButton
            hasIcon={true}
            icon="/icons/stroke/filter.svg"
            iconStyle={{ background: 'none' }}
            style={{ background: '#8A93AC' }}
            colorIcon="var(--white)"
          >
            Filters
          </SecundButton>
        }
      >
        <PanelBoxLayout
          style={{ padding: 15 }}
          titleStyle={{ color: '#2D3748', fontSize: 14 }}
          title="Filters"
          icon="/icons/stroke/filter.svg"
        >
          <Formik
            initialValues={{
              transactionType: '',
              machineIds: [] as (string | number)[],
              from: '',
              to: '',
              transactionTypeTitle: ''
            }}
            // validationSchema={ValidationFilterDate}
            onSubmit={(values, { setSubmitting }) => {
              setFilter({ ...filter, ...values });
              setSubmitting(false);
            }}
          >
            {({ values, errors, touched, handleSubmit, resetForm, setValues }) => (
              <>
                <DropDown
                  label="Type"
                  list={TransactionTypeEnum}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      transactionType: e.id as any,
                      transactionTypeTitle: e.title as any
                    });
                  }}
                  defaultValue={{
                    title: values.transactionTypeTitle,
                    id: values.transactionType
                  }}
                  placeholder="Select Type"
                  message={touched.transactionType && (errors.transactionType as any)}
                  error={errors.transactionType as unknown as boolean}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />

                <Gap size="10px" />

                <DropDown
                  label="Gate"
                  list={machineIds?.data?.map((item: any) => {
                    return { title: item, id: item };
                  })}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      machineIds: [e.id]
                    });
                  }}
                  defaultValue={{
                    title: values.machineIds,
                    id: values.machineIds
                  }}
                  placeholder="Select Gate"
                  message={touched.machineIds && (errors.machineIds as any)}
                  error={errors.machineIds as unknown as boolean}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="10px" />

                <DateInput
                  onChange={(e) => {
                    setValues({
                      ...values,
                      from: e
                    });
                  }}
                  placeholder="From"
                  label="From"
                  defaultDate={values.from}
                  message={touched.from && (errors.from as any)}
                  error={touched.from && (errors.from as unknown as boolean)}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="10px" />

                <DateInput
                  onChange={(e) => {
                    setValues({
                      ...values,
                      to: e
                    });
                  }}
                  placeholder="To"
                  label="To"
                  defaultDate={values.to}
                  message={touched.to && (errors.to as any)}
                  error={touched.to && (errors.to as unknown as boolean)}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="20px" />

                <PrimaryButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={handleSubmit}
                  // disabled={isSubmitting}
                >
                  Filter
                </PrimaryButton>
                <Gap size="10px" />

                <OutlineButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={() => {
                    resetForm();
                    handleSubmit();
                  }}
                  // disabled={isSubmitting}
                >
                  Reset
                </OutlineButton>
              </>
            )}
          </Formik>
        </PanelBoxLayout>
      </MiniPopUp>
    </S.Content>
  );
}
